@import 'styles/mixins';
@import 'styles/variables';

.item {
  display: flex;
  column-gap: 2px;
  margin-right: -28px;
  margin-left: -16px;
  margin-bottom: 12px;

  @include for-phone-only {
    margin-left: 0;
    width: 100%;
  }
}

.grabber {
  display: flex;
  align-items: center;
  opacity: 0;
  width: 16px;

  @include for-phone-only {
    opacity: 1;
  }
}

.body {
  position: relative;
  flex: 1;
}

.chip {
  @include md-regular;
  display: flex;
  align-items: center;
  height: 2em;
  border-radius: 2em;
  padding-left: 10px;
  padding-right: 10px;
}

.divider {
  margin: 8px 0;
  width: 1px;
}

.formContainer {
  display: grid;
  grid-template-columns: 1fr 1px 254px;
  box-shadow: inset 0 0 0 1px var(--neutral-10);
  border-radius: 12px;
  padding: 8px;
  row-gap: 4px;
  column-gap: 10px;
  background-color: var(--neutral-0);

  .divider {
    background: var(--neutral-5);
  }

  &.twoRows {
    .divider,
    .configFieldSet {
      grid-row: span 2;
    }
  }

  @include for-phone-only {
    display: flex;
    flex-direction: column;
  }
}

.form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .divider {
    background: transparent;
    height: 20px;
  }
}

.propertyValueFieldset {
  display: flex;
  flex: 1;
  align-items: center;
  padding: 6px;
  border-radius: 6px;
  height: 40px;
  background: var(--neutral-0);

  &:focus-within {
    box-sizing: border-box;
    box-shadow: inset 0 0 0 1px var(--focus-50), 0 0 0 3px var(--focus-5);
  }

  .divider {
    margin: 8px 6px;
  }

  @include for-phone-only {
    flex-wrap: wrap;
    height: inherit;
  }
}

.textField {
  @include md-regular;
  color: var(--neutral-90);

  &::placeholder {
    color: var(--neutral-30);
  }

  &.description {
    flex: 1;
    display: flex;
    @include line-clamp;
    color: var(--neutral-40);
  }
}

.autoResizingTextField {
  position: relative;

  .spacerText {
    @include md-regular;
    opacity: 0;
    white-space: pre-wrap;
  }

  .textField {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
}

.configFieldSet {
  margin-top: 2px;
  display: flex;
  .twoRows & {
    display: block;
  }
}

.actionPickerPopover {
  width: 274px;
}

.actionPickerItemSettingsIcon {
  margin-left: auto;
}

.defaultStatus {
  color: var(--neutral-40);
  @include md-regular;
  display: inline-flex;
  height: 34px;
  padding: 0 10px;
  align-items: center;
}

.connectionLine {
  --connection-line-width: 7px;

  color: var(--neutral-30);
  width: var(--connection-line-width);
  position: absolute;
  left: calc((var(--connection-line-width) - 1px) / -2);
  top: 24px;

  .arrow {
    fill: currentColor;
    display: block;
  }

  .line {
    background-color: currentColor;
    margin: 1px auto;
    width: 1px;
    height: 36px;
  }

  .dot {
    background-color: currentColor;
    width: var(--connection-line-width);
    height: var(--connection-line-width);
    border-radius: 50%;
  }
}

.rightAction {
  width: 28px;
  display: flex;
  align-items: center;
  opacity: 0;

  @include for-phone-only {
    opacity: 1;
    height: initial;
  }
}

.chipFieldset {
  display: flex;
  align-items: center;

  &.hidden {
    width: 0;
    height: 0;
    display: flex;
    overflow: hidden;
  }
}

.item:hover,
.item:focus-within {
  .formContainer {
    .divider {
      background: var(--neutral-5);
    }
  }
  .rightAction {
    opacity: 1;
  }
}

.draggable:hover {
  .grabber {
    opacity: 1;
  }
}

.draggable.dragging {
  .grabber {
    opacity: 1;
    background-color: var(--neutral-5);
  }
}

.item:hover:not(:focus-within) {
  .formContainer {
    background: var(--neutral-5);
  }

  .form {
    .propertyValueFieldset {
      box-shadow: inset 0 0 0 1px var(--neutral-10);
    }
  }
}

.draggable .item {
  @include for-phone-only {
    margin-left: 0;
    margin-right: 0;
  }
}
